(ns common.schema.entities.fof-asset
  (:require
   [common.schema.entities.asset :as asset]
   [common.schema.entities.common :as common-schema]
   [common.schema.schema-utils :as su]
   [common.currencies :as currencies]))

(def import-fixed-fields
  [:common/external-id
   :asset/name])

(def schema
  (concat
   asset/schema
   (su/option-field-multi :fof-asset/tag-tags
                          "Fund tags"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :in-use})
   (su/option-field :fof-asset/type "Type" {:authorization su/access-ssg-ssg})
   (su/single-ref-field :fof-asset/gp
                        "Fund GP (legal entity)"
                        [:entity.type/company]
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :in-use})
   (su/option-field-multi :fof-asset/target-asset-class
                          "Target asset class"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :in-use})
   (su/datetime-field :fof-asset/datetime-fundraising-until
                      "Fundraising until"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/option-field-multi :fof-asset/pd-sub-asset-class
                          "PD sub asset class"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/re-sub-asset-class
                          "RE sub asset class"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/pe-sub-asset-class
                          "PE sub asset class"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/infra-sub-asset-class
                          "Infra sub asset class"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/geography
                          "Geography"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :in-use})
   (su/option-field-multi :fof-asset/target-company-ebitda
                          "Target company EBITDA (PD/PE only)"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use})
   (su/option-field-multi :fof-asset/peer-group
                          "Peer group"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :in-use})
   (su/integer-field :fof-asset/track-record
                     "Track record"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/track-record-comment
                            "Track record, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/team
                     "Team"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/team-comment
                            "Team, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/deals
                     "Deals"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/deals-comment
                            "Deals, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/platform
                     "Platform"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/platform-comment
                            "Platform, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/fees-etc
                     "Fees etc."
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/fees-etc-comment
                            "Fees etc., comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/fee-discount
                     "Fee discount"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/fee-discount-comment
                            "Fee discount, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/funds-market
                     "Fund's market"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/funds-market-comment
                            "Fund's market, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/funds-market-position
                     "Fund's market position"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/funds-market-position-comment
                            "Fund's market position, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/co-investment
                     "Co-investment"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/co-investment-comment
                            "Co-investment, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/miscellaneous
                     "Miscellaneous"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked
                      :constraints   {:constraint/greater-than-inclusive 1
                                      :constraint/smaller-than-inclusive 5}})
   (su/text-multiline-field :fof-asset/miscellaneous-comment
                            "Miscellaneous, comment"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   [common-schema/common-network-drive-field]
   common-schema/common-network-drives-field
   common-schema/common-folders-path
   (su/currency-field :fof-asset/cur-current-size
                      "Current size"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/currency-field :fof-asset/cur-target-size
                      "Target size"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/esg-restrictions
                            "ESG restrictions"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/percentage-field :fof-asset/carried-interest
                        "Carried interest"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :fof-asset/management-fee
                        "Management fee"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   [[:fof-asset/tag-vintage-year
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        10
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :fof-asset/tag-vintage-year
      :field/default-visibility {:editor :editor.type/none
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-buy-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-buy-side}
      :field/translations       {:en "Vintage year"}}]
    [:fof-asset/tag-sector
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        11
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :fof-asset/tag-sector
      :field/default-visibility {:editor :editor.type/none
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-buy-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-buy-side}
      :field/translations       {:en "Sector"}}]
    [:fof-asset/tag-strategy
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        12
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :fof-asset/tag-strategy
      :field/default-visibility {:editor :editor.type/none
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-buy-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-buy-side}
      :field/translations       {:en "Strategy"}}]]
   (su/keyword-field :fof-asset/home-currency
                     "Home currency"
                     currencies/options
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})

   (su/integer-field :fof-asset/fund-life
                     "Fund life (years)"
                     {:default-field-visibility :not-in-use
                      :authorization su/access-ssg-ssg})
   (su/percentage-field :fof-asset/net-IRR-percentage
                        "Net IRR"
                        {:default-field-visibility :not-in-use
                         :authorization su/access-ssg-ssg})
   (su/percentage-field :fof-asset/gross-IRR-percentage
                        "Gross IRR"
                        {:default-field-visibility :not-in-use
                         :authorization su/access-ssg-ssg})
   (su/multiplier-field :fof-asset/gross-multiple
                        "Gross multiple"
                        {:default-field-visibility :not-in-use
                         :authorization su/access-ssg-ssg})
   (su/multiplier-field :fof-asset/net-multiple
                        "Net multiple"
                        {:default-field-visibility :not-in-use
                         :authorization su/access-ssg-ssg})
   (su/text-multiline-field :fof-asset/exit-terms
                            "Exit terms"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/currency-field :fof-asset/cur-size
                      "Size"
                      {:default-field-visibility :not-in-use
                       :authorization su/access-ssg-ssg})
   (su/text-multiline-field :fof-asset/carried-interest-details
                            "Carried interest details"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/url-field :fof-asset/website "Website" {:authorization su/access-ssg-ssg})
   (su/option-field-multi :fof-asset/strategy
                          "Strategy"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/primary-strategy
                    "Primary strategy"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use})
   (su/option-field-multi :fof-asset/secondary-strategies
                          "Secondary strategies"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use})
   (su/option-field-multi :fof-asset/sector-focus
                          "Sector focus"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/geographical-focus
                          "Geographical focus"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use-blocked})
   (su/currency-field :fof-asset/cur-first-closing-size
                      "First closing size"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/estimated-closing
                     "Estimated closing"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/international-fund-interest-to-nordics
                    "International fund - interest to Nordics"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field-multi :fof-asset/tag-portfolios
                          "Portfolios"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :not-in-use})
   (su/option-field :fof-asset/investment-stage
                    "Investment stage"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use})
   (su/text-simple-field :fof-asset/fund-gp
                         "Fund GP"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use})
   (su/multi-ref-field :fof-asset/risk-entities
                       "Risks"
                       [:entity.type/risk-holding]
                       {:authorization    su/access-user-user
                        :editor-type      :editor.type/none
                        :grid-type        :editor.type/none
                        :filter-type      :filter.type/boolean
                        :required-modules [:module/risk-module]})
   (su/currency-field :fof-asset/hard-cap
                      "Hard cap"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/option-field :fof-asset/consideration-for
                    "Consideration for"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/percentage-field :fof-asset/fund-size-increase
                        "Fund size increase"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/closed
                    "Closed"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/date-field :fof-asset/expected-first-close
                  "Expected first close"
                  {:authorization su/access-ssg-ssg
                   :default-field-visibility :not-in-use-blocked})
   (su/date-field :fof-asset/expected-final-close
                  "Expected final close"
                  {:authorization su/access-ssg-ssg
                   :default-field-visibility :not-in-use-blocked})
   (su/currency-field :fof-asset/ev-target-lower-end
                      "EV target (Lower end)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use-blocked})
   (su/currency-field :fof-asset/ev-target-higher-end
                      "EV target (Higher end)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use-blocked})
   (su/currency-field :fof-asset/ebitda-lower-end
                      "EBITDA (Lower end)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use-blocked})
   (su/currency-field :fof-asset/ebitda-higher-end
                      "EBITDA (Higher end)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/eq-re-up
                    "eQ re-up"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/expected-to-be-oversubscribed
                    "Expected to be oversubscribed"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/team-location
                    "Team location"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/geographical-focus-single-option
                    "Geographical focus"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/text-multiline-field :fof-asset/investment-strategy-in-nutshell
                            "Investment strategy in nutshell"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/sfdr-art
                    "SFDR Art."
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/esg-score
                    "ESG (Score)"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/esg-comment
                         "ESG, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use})
   (su/integer-field :fof-asset/founded
                     "Founded"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/eq-relationship
                     "eQ relationship"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked})
   (su/text-multiline-field :fof-asset/investment-strategy
                            "Investment strategy"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/track-record-text
                            "Track record"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/incentives
                            "Incentives"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/percentage-field :fof-asset/gp-commitment
                        "GP commitment"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :fof-asset/fee-offset
                        "Fee offset"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/text-simple-field :fof-asset/fee-offset-comment
                         "Fee offset, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use})
   (su/text-simple-field :fof-asset/commitment-period-term
                         "Commitment period / Term"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/key-man
                            "Key man"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/pros
                            "Pro's"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/text-multiline-field :fof-asset/cons
                            "Con's"
                            {:authorization su/access-ssg-ssg
                             :default-field-visibility :not-in-use})
   (su/option-field :fof-asset/firm
                    "Firm"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/team-score
                    "Team"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/incentive
                    "Incentive"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/strategy-single-option
                    "Strategy"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/performance
                    "Performance"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/terms
                    "Terms"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/limited-access
                    "Limited access"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/co-investments
                    "Co-investments"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/esg
                    "ESG"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/re-up
                    "Re-up"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/firm-comment
                         "Firm, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/incentive-comment
                         "Incentive, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/strategy-comment
                         "Strategy, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/performance-comment
                         "Performance, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/terms-comment
                         "Terms, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/limited-access-comment
                         "Limited access, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/co-investments-comment
                         "Co-investments, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/re-up-comment
                         "Re-up, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/portfolio-fit
                         "Portfolio fit"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/integer-field :fof-asset/initial-risk-score
                     "Initial risk score"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use-blocked})
   (su/text-simple-field :fof-asset/team-comment-short
                         "Team, comment"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use-blocked})
   (su/option-field :fof-asset/fund-status
                    "Fund status"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use-blocked})
   (su/date-field :fof-asset/date-of-incorporation
                  "Date of incorporation"
                  {:authorization su/access-ssg-ssg
                   :default-field-visibility :not-in-use-blocked})))
